import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const BedGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const BedGroupHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
`

export const BedGroupCrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: ${tokens.font.micro};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${tokens.text.secondary};

  svg {
    width: 0.7rem;
    height: 0.7rem;
    flex: none;
    opacity: 0.6;
  }
`

export const BedGroupPolicy = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const BedRowBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  cursor: pointer;
  transition: all ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    border-color: ${tokens.accent.base};
    background: ${tokens.surface.glass};
  }
`

export const BedRowLabel = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`
